import { PauseSlaResponse, PauseSlaSender } from 'types/SlaPauseTypes';
import useHttp from '../helpers/HttpMethods';

class SlaPauseService {
  /**
   * Busca a pausa ativada no momento.
   * @param {number} ticketId - ID do ticket.
   * @returns {Promise<Response | PauseSlaResponse>}
   */
  static async getActivePause(ticketId: number): Promise<Response | PauseSlaResponse> {
    return await useHttp().get(`/tickets/${ticketId}/sla-pauses/get-active`);
  }

  /**
   * Pausa o sla do ticket.
   * @param {number} ticketId - ID do ticket.
   * @param {PauseSlaSender} body - Tipagem dos dados enviados para pausar o sla do ticket.
   * @returns {Promise<PauseSlaResponse>}
   */
  static async pause(ticketId: number, body: PauseSlaSender): Promise<PauseSlaResponse> {
   return await useHttp().post(body, `/tickets/${ticketId}/sla-pauses`);
  }

  /**
   * Retoma o sla do ticket.
   * @param {number} ticketId - ID do ticket.
   * @returns {Promise<Response | PauseSlaResponse>}
   */
  static async resume(ticketId: number): Promise<Response | PauseSlaResponse> {
    return await useHttp().putWithoutBody(`/tickets/${ticketId}/sla-pauses`);
  }
}

export default SlaPauseService;